import { routeItem } from '@/types';
import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
const RolesListPage = lazy(() => import('./pages/RolesListPage'));

export const roleRoutes: routeItem[] = [
  {
    path: 'roles-permissions',
    element: <Outlet />,
    permission: 'roles.view',
    children: [
      {
        index: true,
        element: <RolesListPage />,
      },
    ],
  },
];